import { handleError } from '@utils/api-error-handling';
import { CLAccounts } from '@modules/front-office/interface/fo-cl-accounts-interface';
import { CLAccountsBookings } from '@modules/front-office/interface/fo-cl-accounts-bookings-interface';
import { api } from '@services/api';

export const clAccountsApi = api
  .enhanceEndpoints({ addTagTypes: ['CLAccounts'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCLAccounts: builder.query({
        query: (query) => {
          return `city-ledger${query}`;
        },
        providesTags: ['CLAccounts'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: CLAccounts) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
      }),
      getCLAccountsBookings: builder.query({
        query: ({ accountID, showIsClosed }) => {
          let queryString = `city-ledger/${accountID}`;
          if (showIsClosed !== undefined) {
            queryString += `?showIsClosed=${showIsClosed}`;
          }
          return queryString;
        },
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
        transformResponse: async (response: CLAccountsBookings) => {
          return response;
        },
        forceRefetch() {
          return true;
        },
      }),
      closeCLAccount: builder.mutation({
        query: (acountRefId) => ({
          url: `city-ledger/${acountRefId}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['CLAccounts'],
        transformErrorResponse: async (baseQueryReturnValue) => {
          return handleError(baseQueryReturnValue);
        },
      }),
    }),
  });

export const {
  useGetCLAccountsQuery,
  useGetCLAccountsBookingsQuery,
  useCloseCLAccountMutation,
} = clAccountsApi;
